import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reporteMateriaPrima';
import ReporteMateriaPrima from './ReporteMateriaPrima';

const mstp = state => {
    return {
        ...state.reporteMateriaPrima,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteMateriaPrima)
